var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestrictedAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 160,
    r: 160,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4443 270.667V90.6672H275.555V270.667C246.431 301.07 205.426 320.001 160 320.001C114.574 320.001 73.5687 301.07 44.4443 270.667Z",
    fill: "#FBFBFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1113 293.057V56.8894H248.889V293.057C223.465 310.076 192.892 320.001 160 320.001C127.109 320.001 96.5353 310.076 71.1113 293.057Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.555 80.0005H92.4443V99.556H227.555V80.0005ZM152.889 115.556H92.4443V184.889H152.889V115.556ZM92.4443 199.112H152.889V268.445H92.4443V199.112ZM227.555 115.556H165.333V184.889H227.555V115.556Z",
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M176 201.778C176 185.578 189.133 172.445 205.333 172.445C221.534 172.445 234.667 185.578 234.667 201.778V225.778H176V201.778Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.222 233.841C165.234 233.841 162 236.982 162 240.857V282.953C162 286.827 165.234 289.969 169.222 289.969H241.445C245.433 289.969 248.667 286.827 248.667 282.953V240.857C248.667 236.982 245.433 233.841 241.445 233.841H169.222ZM147.556 240.857C147.556 229.233 157.256 219.809 169.222 219.809H241.445C253.411 219.809 263.111 229.233 263.111 240.857V282.953C263.111 294.577 253.411 304 241.445 304H169.222C157.256 304 147.556 294.577 147.556 282.953V240.857Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.889 261.905C190.889 254.155 197.356 247.873 205.333 247.873C213.311 247.873 219.778 254.155 219.778 261.905C219.778 269.654 213.311 275.937 205.333 275.937C197.356 275.937 190.889 269.654 190.889 261.905Z",
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.333 174.032C199.587 174.032 194.076 176.25 190.013 180.197C185.95 184.144 183.667 189.498 183.667 195.08V226.825C183.667 230.7 180.433 233.841 176.445 233.841C172.456 233.841 169.222 230.7 169.222 226.825V195.08C169.222 185.776 173.027 176.854 179.799 170.275C186.571 163.696 195.756 160 205.333 160C214.911 160 224.096 163.696 230.868 170.275C237.64 176.854 241.445 185.776 241.445 195.08V226.825C241.445 230.7 238.211 233.841 234.222 233.841C230.234 233.841 227 230.7 227 226.825V195.08C227 189.498 224.717 184.144 220.654 180.197C216.591 176.25 211.08 174.032 205.333 174.032Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestrictedAccess);
export default __webpack_public_path__ + "static/media/restricted_access.b60a6eead9e58dbd40f149d7b146669a.svg";
export { ForwardRef as ReactComponent };